import "./SingleProductTemplate.module.css"
import Header from "@/reusable_sections/Header"
import SingleProductTemplateSection from "./sections/SingleProductTemplateSection"
import MainFooter from "@/reusable_sections/Footer"

export default function SingleProductTemplatePage() {

  return (
    <div>
      <Header />
      <SingleProductTemplateSection />
      <MainFooter />
    </div>
  )
}
